import { generateClient } from 'aws-amplify/api';
import { deleteTimeEntry } from "../graphql/mutations";

const client = generateClient();

export default async ({ id }) => {
    const {
        data: { deleteTimeEntry: timeEntry },
    } = await client.graphql({
        query: deleteTimeEntry,
        variables: {
            input: {
                id
            },
        },
    });
    return timeEntry;
};